<template>
    <div class="reservation-policies">
        <div
            class="reservation-policies__reservation-policy"
            v-for="fee in insuranceFees"
            :key="fee.id"
        >
            <h4>
                {{ fee.title }} - {{ techReservation.tech_reservation.property_name }}
            </h4>
            <p>{{ fee.description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        techReservation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        insuranceFees() {
            return this.techReservation.all_fees.filter((fee) => {
                return fee.is_insurance;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    .reservation-policies{
        &__reservation-policy{
            margin-bottom: 2rem;
            h4 {
                font-size: 14px;
                font-weight: bold;
                line-height: 1;
                margin-bottom: 0;
            }
            p {
                font-size: 14px;
                margin-top: 5px;
                line-height: 1.5;
                margin-bottom: 0;
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
    }
</style>
